import { DialogContent, Table, TableBody, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ReleaseDialogTableRow from './ReleaseResourceRequestDialogTableRow';
import ReleaseDialogTableHeader from './ReleaseResourceRequestDialogTableHeader';
import ResourceAllocationDetails from './ResourceAllocationDetails';

const useContentStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'block'
  },
  model1: {
    backgroundColor: theme.palette.grey[50]
  }
}));

export const ReleaseResourceAllocationsDialogContent = ({
  isPsaRmpTaskAllocation1Enabled,
  onSelectAllClick,
  onRowSelectionChange,
  allocations,
  allocatedUser
}) => {
  const classes = useContentStyles();

  const tableCellContent = allocation => (
    <>
      {allocation.role && <span>{allocation.role.displayText}</span>}
      {!allocation.role && (
        <span>
          <FormattedMessage id="releaseResourceRequestDialog.noRole" />
        </span>
      )}
    </>
  );

  return (
    <DialogContent
      id="release-allocation-dialog-content"
      className={classNames(classes.root, {
        [classes.model1]: isPsaRmpTaskAllocation1Enabled
      })}
    >
      {isPsaRmpTaskAllocation1Enabled ? (
        <ResourceAllocationDetails
          allocatedUser={allocatedUser}
          allocations={allocations}
        />
      ) : (
        <Table>
          <ReleaseDialogTableHeader
            usersCount={allocations.length}
            selectedCount={allocations.filter(a => a.isSelected).length}
            onSelectAllClick={onSelectAllClick}
            headerId="releaseResourceRequestDialog.role"
          />
          <TableBody>
            {allocations.map(allocation => (
              <ReleaseDialogTableRow
                key={allocation.id}
                allocation={allocation}
                onRowSelectionChange={onRowSelectionChange}
                tableCellContent={tableCellContent(allocation)}
              />
            ))}
          </TableBody>
        </Table>
      )}
    </DialogContent>
  );
};

ReleaseResourceAllocationsDialogContent.propTypes = {
  allocations: PropTypes.array.isRequired,
  allocatedUser: PropTypes.object,
  isPsaRmpTaskAllocation1Enabled: PropTypes.bool,
  onRowSelectionChange: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired
};

export default ReleaseResourceAllocationsDialogContent;
